<template>
	<v-dialog
		class="dialog"
		v-model="visible"
		:max-width="maxWidth"
		persistent
	>
		<v-alert
			border="top"
			colored-border
			:color="type"
		>
			<div class="title-text">{{ title_text }}</div>
			<div class="content-text">{{ content_text }}</div>
			<div class="button">
				<v-btn outlined color="rgba(25, 42, 62, 0.7)" class="text-capitalize" @click="$emit('cancel')">{{ cancel_button }}</v-btn>
				<v-btn depressed :color="buttonColor" class="ml-2 white--text text-capitalize" @click="$emit('ok')">
					<v-icon v-if="icon_name.length !== 0" class="mr-2">{{icon_name}}</v-icon>
					{{ confirm_button }}
					<component
						v-if="icon" 
						:is="icon.name"
						:color="icon.color" 
						:width="icon.width" 
						:height="icon.height"
						class="exit-icon" 
					/>
				</v-btn>
			</div>
		</v-alert>
	</v-dialog>
</template>

<script>
import Exit from "@/components/icons/exit";

export default {
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		title_text: {
			type: String,
			default: ''
		},
		content_text: {
			type: String,
			default: ''
		},
		confirm_button: {
			type: String,
			default: 'Confirm'
		},
		cancel_button: {
			type: String,
			default: 'Cancel'
		},
		type: {
			/*  info: blue, error: red, warning: yellow */
			type: String,
			default: 'info'
		},
		buttonColor: {
			type: String,
			default: '#00AAFD'
		},
		icon: {
			type: Object,
			default: null
		},
		icon_name: {
			type: String,
			default: ''
		},
		maxWidth: {
			type: Number,
			default: 400
		}
	},
	components: {
		Exit
	},
	data() {
		return {}
	},
}	
</script>

<style scoped>
.dialog {
	padding: 20px;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}
.content-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  margin: 15px 0;
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.exit-icon { 
  margin-left: 16px;
}
.v-alert {
	margin-bottom: 0;
}
</style>

